import { useState, useEffect } from 'react'
import styled from 'styled-components'

interface ProgressiveImgProps {
  src: string
  placeholderSrc: string
  alt?: string
  [key: string]: any
}

const ProgressiveImg: React.FC<ProgressiveImgProps> = ({
  src,
  placeholderSrc,
  ...props
}) => {
  const [imgSrc, setImgSrc] = useState(placeholderSrc || src)

  useEffect(() => {
    const img = new Image()
    img.src = src
    img.onload = () => {
      setImgSrc(src)
    }
  }, [src])

  return (
    <ImageWrapper
      {...{ src: imgSrc, ...props }}
      placeholderSrc={placeholderSrc}
      alt={props.alt || ''}
    />
  )
}

export default ProgressiveImg

const ImageWrapper = styled.img<{ src: string; placeholderSrc: string }>`
  filter: ${({ src, placeholderSrc }) =>
    src === placeholderSrc ? 'blur(3px)' : 'blur(0)'};
`
